import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import { LoggedInCallback } from '../services/cognito.service';
import { UserLoginService } from '../services/user-login.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private userLoginService: UserLoginService) {}

  canActivate(): Promise<boolean> {
    return new Promise(resolve => {
      this.userLoginService
        .isAuthenticated()
        .then(loggedIn => {
          if (!loggedIn) {
            this.router.navigate(['/login']);
          }
          resolve(loggedIn);
        })
        .catch(err => {
          this.router.navigate(['/login']);
          resolve(false);
        });
    });
  }

  checkAuthorization(state): Promise<any> {
    return new Promise(resolve => {
      this.userLoginService.isAuthorized(state).then(
        function() {
          resolve();
        },
        err => {
          this.router.navigate(['/login']);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/auth.guard.ts